export default "__VITE_ASSET__DwffNQRE__"